export class FinancialType {
  financialTypeId: number;
  sortOrder: number;
  name: string;
}
